import { api } from './client'

// FR-32 Training Hub API.
// classId opsional: menyaring sesi "Live" ke satu angkatan; kosong berarti
// seluruh program seperti sebelumnya.
export const getTrainingHubOverview = (pid, classId) =>
  api
    .get(`/training-hub/programs/${pid}/overview`, {
      params: classId ? { class_id: classId } : undefined,
    })
    .then((r) => r.data)
export const getTrainingHubParticipant = (pid) =>
  api.get(`/training-hub/programs/${pid}/participant`).then((r) => r.data)
